import { ACTION_SET_MOBILE_CONNECTION_DATA } from "./names.js";

/**
 * @param {Object} data
 */
function changeConnectionData(data) {
  return {
    type: ACTION_SET_MOBILE_CONNECTION_DATA,
    payload: data,
  };
}

export default {
  changeConnectionData,
};
